export class User {
  id: number;
  email: string;
  firstName: string;
  language: string;
  onboardingDone: boolean;
  numberOfStreakDays: number;
  isPremiumUser: boolean;
  upgradePromptAfterFirstRevisionShown: boolean;
  currentWeekActivity: any[];

  constructor(id: number, email: string, firstName: string, language: string, onboardingDone: boolean, numberOfStreakDays: number, isPremiumUser: boolean, upgradePromptAfterFirstRevisionShown: boolean, currentWeekActivity: any[]) {
    this.id = id;
    this.email = email;
    this.firstName = firstName;
    this.language =  language;
    this.onboardingDone = onboardingDone;
    this.numberOfStreakDays = numberOfStreakDays;
    this.isPremiumUser = isPremiumUser;
    this.upgradePromptAfterFirstRevisionShown = upgradePromptAfterFirstRevisionShown;
    this.currentWeekActivity = currentWeekActivity;
  }

  public static constructUser(data: any): User {
    return new User(data.id, data.email, data.firstName, data.language, data.onboardingDone, data.numberOfStreakDays, data.isPremiumUser, data.upgradePromptAfterFirstRevisionShown, data.currentWeekActivity);
  }
}